import React from 'react';
import Redirect from 'components/Redirect';
import { loginPagePath } from '.';

// this supports SSR redirects
export function RedirectToLoginPage() {
  return <Redirect to={loginPagePath()} replace />;
}
